import { CookieSessionData } from '../../Models/CookieSessionData';
import {
    IAllowHomeNavigate,
    IChangePortalBusy,
    ISetAddUsers,
    ISetModifyWorkspaceUsersState,
    ISetRedirectAfterLogin,
    ISetShowDataCollectionLimitsDetails,
    ISetUserIsAuthenticated,
    IUpdateLastUserInteraction,
    IUpdateUIStateTimer,
    UIStateActions,
} from './Actions';
import { ModifyWorkspaceUsersState, UIRedirectSearchParams } from './Reducer';

function SetAddUsers(isActive: boolean): ISetAddUsers {
    return {
        type: UIStateActions.SetAddUsers,
        isActive,
    };
}

function AllowHomeNavigate(allow: boolean): IAllowHomeNavigate {
    return {
        type: UIStateActions.SetHomeNavigate,
        allow,
    }
}

function SetPortalWorking(source: string): IChangePortalBusy {
    return {
        type: UIStateActions.ChangePortalBusy,
        increment: 1,
        source
    };
}

function SetPortalIdle(source: string): IChangePortalBusy {
    return {
        type: UIStateActions.ChangePortalBusy,
        increment: -1,
        source
    };
}

function SetRedirectAfterLogin(path?: string, searchParams?: UIRedirectSearchParams): ISetRedirectAfterLogin {
    return {
        type: UIStateActions.SetRedirectAfterLogin,
        path,
        searchParams
    };
}

function SetModifyWorkspaceUsersState(data?: ModifyWorkspaceUsersState): ISetModifyWorkspaceUsersState {
    return {
        type: UIStateActions.SetModifyWorkspaceUsersState,
        data,
    }
}

function UpdateLastUserInteraction(): IUpdateLastUserInteraction {
    return {
        type: UIStateActions.UpdateLastUserInteraction
    }
}

function UpdateUIStateTimer(cookieSessionData: CookieSessionData): IUpdateUIStateTimer {
    return {
        type: UIStateActions.UpdateUIStateTimer,
        cookieSessionData,
    }
}

function SetShowDataCollectionLimitsDetails(show: boolean): ISetShowDataCollectionLimitsDetails {
    return {
        type: UIStateActions.SetShowDataCollectionLimitsDetails,
        show,
    };
}

function SetUserIsAuthenticated(authenticated: boolean): ISetUserIsAuthenticated {
    return {
        type: UIStateActions.SetUserIsAuthenticated,
        authenticated,
    };
}

export const actionCreators = {
    SetAddUsers: SetAddUsers,
    SetRedirectAfterLogin: SetRedirectAfterLogin,
    SetPortalWorking: SetPortalWorking,
    SetPortalIdle: SetPortalIdle,
    AllowHomeNavigate: AllowHomeNavigate,
    SetModifyWorkspaceUsersState: SetModifyWorkspaceUsersState,
    UpdateLastUserInteraction: UpdateLastUserInteraction,
    UpdateUIStateTimer: UpdateUIStateTimer,
    SetShowDataCollectionLimitsDetails: SetShowDataCollectionLimitsDetails,
    SetUserIsAuthenticated: SetUserIsAuthenticated,
};
